import { render, staticRenderFns } from "./CategoryDropdown.vue?vue&type=template&id=0c9ff19d&scoped=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=js"
export * from "./CategoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./CategoryDropdown.vue?vue&type=style&index=0&id=0c9ff19d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ff19d",
  null
  
)

export default component.exports